module.exports = __webpack_public_path__ + "img/socup.c5254336.svg";